/**
 * Inline SVG logo placeholders for new sponsors.
 * These are minimal vector logos rendered as data URLs so they can be used
 * directly as <img src=...>. When real artwork is provided we can swap them.
 */

function svg(content, { w = 100, h = 100, bg = "#000" } = {}) {
  const xml = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w} ${h}" width="${w}" height="${h}"><rect width="${w}" height="${h}" fill="${bg}"/>${content}</svg>`;
  return `data:image/svg+xml;utf8,${encodeURIComponent(xml)}`;
}

export const DYD_LOGO = svg(
  `<circle cx="50" cy="50" r="42" fill="#CCFF00"/>
   <text x="50" y="46" text-anchor="middle" font-family="Arial Black, sans-serif" font-weight="900" font-size="24" fill="#000" letter-spacing="-1">DYD</text>
   <text x="50" y="68" text-anchor="middle" font-family="Arial, sans-serif" font-weight="700" font-size="8" fill="#000" letter-spacing="2">PÁDEL</text>
   <path d="M30 80 L70 80" stroke="#000" stroke-width="2"/>`,
  { bg: "#000" },
);

export const CLUB_PREMIER_LOGO = svg(
  `<path d="M50 8 L92 30 L92 70 L50 92 L8 70 L8 30 Z" fill="#0D1B4C" stroke="#FFD700" stroke-width="3"/>
   <text x="50" y="44" text-anchor="middle" font-family="Georgia, serif" font-weight="bold" font-size="14" fill="#FFD700">CLUB</text>
   <text x="50" y="62" text-anchor="middle" font-family="Georgia, serif" font-weight="bold" font-size="11" fill="#FFD700" letter-spacing="2">PREMIER</text>
   <circle cx="50" cy="76" r="2" fill="#FFD700"/>`,
  { bg: "#FFFFFF" },
);

export const LOS_ENCINOS_LOGO = svg(
  `<circle cx="50" cy="50" r="44" fill="#1B5E20"/>
   <path d="M40 35 Q50 25 60 35 Q65 45 60 55 Q70 60 65 70 Q55 75 50 70 Q45 75 35 70 Q30 60 40 55 Q35 45 40 35 Z" fill="#FFFFFF" opacity="0.9"/>
   <text x="50" y="86" text-anchor="middle" font-family="Arial, sans-serif" font-weight="900" font-size="8" fill="#FFFFFF" letter-spacing="1">LOS ENCINOS</text>`,
  { bg: "#FFFFFF" },
);

export const PADELVILLE_LOGO = svg(
  `<rect x="6" y="6" width="88" height="88" rx="14" fill="#7C4DFF"/>
   <text x="50" y="44" text-anchor="middle" font-family="Verdana, sans-serif" font-weight="900" font-size="20" fill="#FFFFFF">PADEL</text>
   <text x="50" y="66" text-anchor="middle" font-family="Verdana, sans-serif" font-weight="900" font-size="18" fill="#FFD700" letter-spacing="1">VILLE</text>
   <circle cx="50" cy="78" r="3" fill="#FFD700"/>`,
  { bg: "#FFFFFF" },
);

export const PADEL_CENTER_LOGO = svg(
  `<circle cx="50" cy="50" r="42" fill="#E60023"/>
   <text x="50" y="42" text-anchor="middle" font-family="Impact, sans-serif" font-size="16" fill="#FFFFFF" letter-spacing="-0.5">PADEL</text>
   <text x="50" y="62" text-anchor="middle" font-family="Impact, sans-serif" font-size="14" fill="#FFFFFF" letter-spacing="1">CENTER</text>
   <path d="M22 76 L78 76" stroke="#FFFFFF" stroke-width="2"/>`,
  { bg: "#000" },
);

export const DUMA_LOGO = svg(
  `<rect x="5" y="5" width="90" height="90" rx="6" fill="#0066FF"/>
   <text x="50" y="58" text-anchor="middle" font-family="Arial Black, sans-serif" font-weight="900" font-size="28" fill="#FFFFFF" letter-spacing="2">DUMA</text>
   <path d="M20 72 L80 72" stroke="#FFFFFF" stroke-width="2"/>`,
  { bg: "#FFFFFF" },
);

export const MUNICH_LOGO = svg(
  `<rect x="5" y="5" width="90" height="90" rx="50" fill="#E63946"/>
   <text x="50" y="58" text-anchor="middle" font-family="Arial Black, sans-serif" font-weight="900" font-size="18" fill="#FFFFFF" letter-spacing="2">MÚNICH</text>
   <circle cx="50" cy="76" r="3" fill="#FFFFFF"/>`,
  { bg: "#FFFFFF" },
);

export const BRAND_LOGOS = {
  dyd: DYD_LOGO,
  club_premier: CLUB_PREMIER_LOGO,
  los_encinos: LOS_ENCINOS_LOGO,
  padelville: PADELVILLE_LOGO,
  padel_center: PADEL_CENTER_LOGO,
  duma: DUMA_LOGO,
  munich: MUNICH_LOGO,
};
